import api from "@/lib/api";

// ---- Loja (público) ----
export const getStoreProducts = (params = {}) =>
  api.get("/store/products", { params }).then((r) => r.data);
export const getStoreCatalog = () => api.get("/store/catalog").then((r) => r.data);
export const getStoreExamples = () => api.get("/store/examples").then((r) => r.data);
export const getStoreShowcase = (limit = 12) =>
  api.get("/store/showcase", { params: { limit } }).then((r) => r.data);

// ---- Minhas encomendas (auth) ----
export const getMyOrders = () => api.get("/my/orders").then((r) => r.data);
export const getMyOrder = (id) => api.get(`/my/orders/${id}`).then((r) => r.data);
export const approveSuggestion = (orderId, suggestionId) =>
  api.post(`/my/orders/${orderId}/approve`, { suggestion_id: suggestionId }).then((r) => r.data);

// ---- Estados de encomenda ----
export const ORDER_STATUS_LABELS = {
  pending: "Aguarda pagamento",
  paid: "Pago — a preparar sugestões",
  suggestions_ready: "Sugestões disponíveis",
  approved: "Sugestão aprovada",
  production: "Em produção",
  shipped: "Expedido",
  delivered: "Entregue",
  cancelled: "Cancelado",
  expired: "Expirado",
  refunded: "Reembolsado",
};

export const ORDER_STATUS_COLORS = {
  pending: "text-[#FFC861] border-[#FFB020]/40 bg-[#FFB020]/10",
  paid: "text-[#7FB5FF] border-[#3B82F6]/40 bg-[#3B82F6]/10",
  suggestions_ready: "text-[#FF7A4D] border-[#FF3B00]/40 bg-[#FF3B00]/10",
  approved: "text-[#C39BFF] border-[#8B5CF6]/40 bg-[#8B5CF6]/10",
  production: "text-[#7FDDF0] border-[#06B6D4]/40 bg-[#06B6D4]/10",
  shipped: "text-[#9BE7B4] border-[#22C55E]/40 bg-[#22C55E]/10",
  delivered: "text-[#5BBF7B] border-[#22C55E]/50 bg-[#22C55E]/15",
  cancelled: "text-[#8B8B93] border-[#3F3F46] bg-[#1A1A1E]",
  expired: "text-[#8B8B93] border-[#3F3F46] bg-[#1A1A1E]",
  refunded: "text-[#C39BFF] border-[#8B5CF6]/40 bg-[#8B5CF6]/10",
};

export const ORDER_FLOW = [
  "pending",
  "paid",
  "suggestions_ready",
  "approved",
  "production",
  "shipped",
  "delivered",
];
